<template>
  <div>
    <div v-for="(partner, idx) in partners" :key="idx">
      <el-row>
        <el-col :xs="24" :md="24">
          <span class="el-form-item__label" v-text="getSwitchText(partner.partner_name)"></span>
          <el-switch
            v-model="partner.is_for_delete"
            :labelText="getNameBranch(partner.partner_name)"
            :active-value="false"
            :inactive-value="true"
            :disabled="partner.partnerDisabled"
            @change="onSwitch(idx)"
          >
          </el-switch>
        </el-col>
      </el-row>
      <el-row v-if="partner.partnerDisabled">
        <el-col :span="24">
          <el-alert type="warning" show-icon :title="$t('api.branch.fields.partner.limit')"></el-alert>
        </el-col>
      </el-row>
      <el-row>
        <el-col :xs="24" :md="12">
          <text-field
            v-model="partner.branch_id"
            base="branch"
            name="partner.branch"
            :disabled="partner.is_for_delete || partner.product_mapping_type === PartnerProductMappingType.BY_PARTNER"
            :prop="getBranchIDPropPath(partner.partner_id)"
            :labelText="getNameBranch(partner.partner_name)"
            :show-message="!partner.is_for_delete"
            :required="!partner.is_for_delete && partner.product_mapping_type !== PartnerProductMappingType.BY_PARTNER"
            :rules="getRules(idx)"
            @change="updatePartners(partner.partner_name)"
            >
          </text-field>
        </el-col>
      </el-row>
      <el-divider v-if="idx !== partners.length - 1"></el-divider>
    </div>
  </div>
</template>

<script>

import { getTransText } from '@/utils/i18n'
import { fetchList as fetchPartnerList } from '@/api/merchant/partner'
import { PartnerType, PartnerProductMappingType, PartnerStatus } from '@/enums/partner'
import { usePartnerList } from '@/composables/partner/usePartnerList'

export default {
  name: 'branch-partner',
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  setup () {
    const { sortPartners } = usePartnerList()

    return {
      sortPartners
    }
  },
  data () {
    return {
      partners: [],
      PartnerProductMappingType
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    tidyPartners () {
      return this.partners.filter(p => !p.is_for_delete || p.id).map(p => ({
        id: p.id,
        partner_id: p.partner_id,
        branch_id: p.branch_id,
        is_for_delete: p.is_for_delete
      }))
    }
  },
  methods: {
    getTransText,
    onSwitch (idx) {
      if (this.partners[idx].is_for_delete) {
        this.partners[idx].branch_id = ''
      }

      this.updatePartners()
    },
    updatePartners () {
      this.$emit('input', this.tidyPartners)
    },
    async fetchData () {
      try {
        const query = {filter: `{type: ${PartnerType.Client}}`}
        const res = await fetchPartnerList(query)
        this.partners = this.sortPartners(res.data).map(partnerConfig => {
          const partnerSetting = this.value.find(v => v.partner_id === partnerConfig.id)
          return {
            ...partnerConfig,
            id: partnerSetting ? partnerSetting.id : undefined,
            partner_id: partnerConfig.id,
            partner_name: partnerConfig.name,
            branch_id: partnerSetting ? partnerSetting.branch_id : '',
            is_for_delete: partnerSetting ? partnerSetting.is_for_delete : true,
            partnerDisabled: partnerConfig.status === PartnerStatus.DISABLE || false
          }
        })
      } catch (error) {
        console.log(error)
      }
    },
    getNameBranch (partnerName) {
      return partnerName + ' ' + this.$t('api.branch.fields.partner.branch.label')
    },
    getSwitchText (partnerName) {
      return partnerName + ' ' + this.$t('api.branch.fields.partner.branch.switch')
    },
    getBranchIDPropPath (partnerID) {
      let idx = this.value.findIndex(v => v.partner_id === partnerID)

      return (idx === -1) ? '' : `partner.${idx}.branch_id`
    },
    getRules (idx) {
      let partner = this.partners[idx]
      if (partner.partner_id === 3 && !partner.is_for_delete) {
        return [{
          validator: (rule, value, callback) => {
            let onlyNum = /^\d+$/
            if (!onlyNum.test(value)) {
              callback(new Error(this.getTransText('partner.branch', 'errNum', 'branch')))
              return
            }

            callback()
          },
          trigger: 'blur'
        }]
      }
    }
  }
}
</script>
